export default __webpack_public_path__ + "static/media/img-slider-om-wallet-5.ce1d0ad8.png";